import React from 'react';
import { getAppEnvLabel, isInviteOnlyBuild } from '../utils/stagingAccess';

/** Persistent banner on non-prod builds so the environment is never confused with prod. */
export default function StagingBanner() {
  if (!isInviteOnlyBuild()) return null;

  const env = getAppEnvLabel();
  const label = env === 'development' ? 'DEVELOPMENT' : 'STAGING';
  const detail =
    env === 'development'
      ? 'Dev environment. Experiments and test data only. Not production.'
      : 'Test data and Stripe test mode only. Not production.';

  return (
    <div
      className={
        env === 'development'
          ? 'bg-sky-600 text-white text-center text-xs sm:text-sm font-semibold py-1.5 px-3 tracking-wide'
          : 'bg-amber-500 text-amber-950 text-center text-xs sm:text-sm font-semibold py-1.5 px-3 tracking-wide'
      }
      role="status"
    >
      {label} · {detail}
    </div>
  );
}
